@if (showBanner()) {
  <div class="pwa-banner">
    <div class="pwa-banner__content">
      <div class="pwa-banner__icon">
        <mat-icon>download</mat-icon>
      </div>
      <div class="pwa-banner__text">
        <p class="pwa-banner__title">{{ 'pwa_install_title' | translate }}</p>
        <p class="pwa-banner__subtitle">{{ 'pwa_install_subtitle' | translate }}</p>
      </div>
    </div>
    <div class="pwa-banner__actions">
      <button class="pwa-banner__install-btn" (click)="install()">
        {{ 'pwa_install_button' | translate }}
      </button>
      <button class="pwa-banner__dismiss-btn" (click)="dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}

@if (showIosInstructions()) {
  <div class="ios-overlay" (click)="closeInstructions()">
    <div class="ios-instructions" (click)="$event.stopPropagation()">
      <button class="ios-instructions__close" (click)="closeInstructions()">
        <mat-icon>close</mat-icon>
      </button>
      <p class="ios-instructions__title">{{ 'pwa_ios_title' | translate }}</p>

      <div class="ios-instructions__steps">
        <div class="ios-instructions__step">
          <div class="ios-instructions__step-number">1</div>
          <div class="ios-instructions__step-content">
            <mat-icon class="ios-instructions__step-icon">ios_share</mat-icon>
            <span>{{ 'pwa_ios_step1' | translate }}</span>
          </div>
        </div>
        <div class="ios-instructions__step">
          <div class="ios-instructions__step-number">2</div>
          <div class="ios-instructions__step-content">
            <mat-icon class="ios-instructions__step-icon">add_box</mat-icon>
            <span>{{ 'pwa_ios_step2' | translate }}</span>
          </div>
        </div>
        <div class="ios-instructions__step">
          <div class="ios-instructions__step-number">3</div>
          <div class="ios-instructions__step-content">
            <mat-icon class="ios-instructions__step-icon">check_circle</mat-icon>
            <span>{{ 'pwa_ios_step3' | translate }}</span>
          </div>
        </div>
      </div>

      <button class="ios-instructions__done-btn" (click)="closeInstructions()">
        {{ 'pwa_ios_done' | translate }}
      </button>
    </div>
  </div>
}
